import {
  buildOpportunityFiles,
  buildOpportunityPayload,
  OpportunityFilePayload,
} from './buildPayload'
import { OpportunityFormData } from './types'
import {
  buildSaveOpportunityRequest,
  removeOpportunityFiles,
} from '../api/scoutingService'

export const markOpportunityFileForRemoval = (
  removedFileIds: string[],
  fileId?: string
): string[] => {
  if (!fileId) return removedFileIds
  return [...new Set([...removedFileIds, fileId])]
}

export const getVisibleExistingSupportFiles = (form: OpportunityFormData) =>
  (form.existingSupportFiles ?? []).filter(
    file => !(form.removedFileIds ?? []).includes(file.id)
  )

export const hasVisibleExistingCover = (form: OpportunityFormData): boolean => {
  if (!form.existingCoverImagePath?.trim()) return false
  if (!form.existingCoverImageId) return true
  return !(form.removedFileIds ?? []).includes(form.existingCoverImageId)
}

export const syncOpportunityOnSave = async (
  form: OpportunityFormData,
  saveOpportunity: (request: ReturnType<typeof buildSaveOpportunityRequest>) => Promise<unknown>,
  options: {
    defaultStatusId?: string
    opportunityId?: string
  }
): Promise<unknown> => {
  const fileIdsToRemove = [...new Set((form.removedFileIds ?? []).filter(Boolean))]

  if (fileIdsToRemove.length > 0) {
    await removeOpportunityFiles(fileIdsToRemove)
  }

  const filesToUpload: OpportunityFilePayload[] = await buildOpportunityFiles(form)
  const payload = buildOpportunityPayload(
    form,
    options.defaultStatusId,
    options.opportunityId,
    filesToUpload
  )

  return saveOpportunity(buildSaveOpportunityRequest(payload.data))
}
